import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { DatePickerProps as AntDatePickerProps } from 'antd';
import dayjs from 'dayjs';

import { DatePicker, DatePickerProps } from '@/shared/uikitV2/Datepicker';

type DatePickerRangePairProps = {
  watchFieldName: string;
  isDateRangePair: boolean;
} & DatePickerProps;

export const DatePickerComponent: FC<DatePickerRangePairProps> = ({
  watchFieldName,
  isDateRangePair,
  ...props
}) => {
  const dateRangePairProps: Omit<AntDatePickerProps, 'value' | 'onChange'> = {};
  const { watch } = useFormContext<Record<string, dayjs.ConfigType>>();

  if (isDateRangePair) {
    const watchedValue = watch(watchFieldName);

    dateRangePairProps.disabledDate = (current) => {
      if (!current || !watchedValue) return false;

      return current.isBefore(dayjs(watchedValue), 'day');
    };
  }

  return <DatePicker {...dateRangePairProps} {...props} />;
};
